module.exports = {

    data: function() {
    	return {
            savingOrderedStatus: false,
            savingInvoicedStatus: false
    	}
    },

    computed: {
    	shouldShowOrderAndInvoiceOptions: function() {
            return this.canUpdateChangeOrder && this.isApproved && this.isExpanded && !this.changeorder.is_template && !this.changeorder.is_draft;
        },

        orderedDate: function() {
            if (this.changeorder.ordered_date) {
                return this.formattedDate(this.changeorder.ordered_date);
            }

            return null;
        },

        invoicedDate: function() {
            if (this.changeorder.invoiced_date) {
                return this.formattedDate(this.changeorder.invoiced_date);
            }

            return null;
        },

        approvedDate: function() {
            if (this.isApproved && this.changeorder.signed_at) {
                return this.formattedDate(this.changeorder.signed_at);
            }

            return null;
        },

        isOrdered: function() {
            return this.changeorder.status_ordered;
        },

        isInvoiced: function() {
            return this.changeorder.status_invoiced !== '0%';
        },

        orderedButtonClass: function() {
            // if (this.isOrdered) {
            //     return "btn-light"
            // }
            return "btn-light";
        },

        orderedButtonIcon: function() {
            if (this.isOrdered) {
                return "fas fa-shipping-fast"
            }
            return "fas fa-clock";
        },

        orderedStatus: function() {
            if (this.isOrdered) {
                return "Ordered";
            }
            return "Not ordered";
        },

        invoicedButtonClass: function() {
            // if (this.isInvoiced) {
            //     return "btn-light"
            // }
            return "btn-light";
        },

        invoicedButtonIcon: function() {
            if (this.isInvoiced) {
                return "fas fa-file-invoice-dollar"
            }
            return "fas fa-clock";
        },

        invoicedStatusPercent: function() {
            return this.changeorder.status_invoiced;
        },

        invoicedStatus: function() {
            if (this.changeorder.status_invoiced === '100%') {
                return "Invoiced";
            } else if (this.changeorder.status_invoiced === '50%') {
                return '50% Invoiced';
            }

            return "Not invoiced";
        },
    },

    methods: {
        formattedDate: function(date) {
            return moment(date).format('MMMM D YYYY');
        },

        setOrderedDate: function(date) {
            this.savingOrderedStatus = true;
            axios.post(`/api/changeorders/${this.changeorder.id}/ordered`, {
                    date: date,
                })
                .then(response => {
                	if (this.changeorder.is_selection) {
                    	Bus.$emit('selection-updated', response.data);
                	}
                	else {
                		Bus.$emit('change-order-updated', response.data);
                	}
                    this.savingOrderedStatus = false;
                })
                .catch(error => {
                    this.savingOrderedStatus = false;;
                });
        },

        setInvoicedDate: function(date) {
            this.savingInvoicedStatus = true;
            axios.post(`/api/changeorders/${this.changeorder.id}/invoiced`, {
                    date: date,
                    invoiced: this.invoicedStatusPercent,
                })
                .then(response => {
                    if (this.changeorder.is_selection) {
                    	Bus.$emit('selection-updated', response.data);
                	}
                	else {
                		Bus.$emit('change-order-updated', response.data);
                	}
                    this.savingInvoicedStatus = false;
                })
                .catch(error => {
                    this.savingInvoicedStatus = false;
                });
        },

        dateFromString: function(dateString) {
            if (dateString) {
                return moment(dateString).toDate();
            }
            return null;
        },

        orderDropdownClicked: function(ordered) {
            this.savingOrderedStatus = true;
            axios.post(`/api/changeorders/${this.changeorder.id}/ordered`, {
                    ordered: ordered,
                })
                .then(response => {
                    if (this.changeorder.is_selection) {
                    	Bus.$emit('selection-updated', response.data);
                	}
                	else {
                		Bus.$emit('change-order-updated', response.data);
                	}
                    this.savingOrderedStatus = false;
                })
                .catch(error => {
                    this.savingOrderedStatus = false;
                });
        },

        invoiceDropdownClicked: function(invoiced) {
            this.savingInvoicedStatus = true;
            axios.post(`/api/changeorders/${this.changeorder.id}/invoiced`, {
                    invoiced: invoiced,
                })
                .then(response => {
                    if (this.changeorder.is_selection) {
                    	Bus.$emit('selection-updated', response.data);
                	}
                	else {
                		Bus.$emit('change-order-updated', response.data);
                	}
                    this.savingInvoicedStatus = false;
                })
                .catch(error => {
                    this.savingInvoicedStatus = false;
                });
        },
    }
};
